/* eslint-disable no-undef */
export function isMobile() {
  return (
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/Android/i)
  );
}

export function isAndroid() {
  return navigator.userAgent.match(/Android/i);
}

export function isWebBrowserAndroid() {
  return navigator.userAgent.match(/Android/i) && navigator.userAgent.match(/Mobile Safari/i);
}

export function isIpad() {
  return navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i);
}

export function isSafari() {
  let result = false;
  const ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('safari') !== -1) {
    if (ua.indexOf('chrome') > -1) {
      result = false; // Chrome
    } else {
      result = true; // Safari
    }
  }
  return result;
}

export function isIphone() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

export function isChrome() {
  return (
    navigator.userAgent.match(/Chrome/i) != null || navigator.userAgent.match(/Crios/i) != null
  );
}

export function isFireFox() {
  return navigator.userAgent.match(/Firefox/i) != null;
}

export function isIE11() {
  return navigator.userAgent.match(/rv:11\.0/i) != null;
}
